import ('./mobile-service-map.scss');

/**
 * Represents a mobile service map.
 * @class
 */
export default class MobileServiceMap {

  #dom = {};
  #areaData = {}; // area data from window.mobileServiceMapData (database)
  #activeClassName = 'st7'; // this style is in SVG map file

  /**
   * Creates an instance of MobileServiceMap.
   * @param {HTMLElement} mapWrapperEl - The element containing SVG map.
   */
  constructor(mapWrapperEl) {
    this.#dom.element = mapWrapperEl;
    this.#dom.map = mapWrapperEl.querySelector('svg');
    this.#areaData = window.mobileServiceMapData;
  }

  /**
   * Find elements from the DOM.
   */
  findElements() {
    this.#dom.paths = Array.from(this.#dom.map.querySelectorAll('[id^="area-"]'));
    this.#dom.triggers = Array.from(this.#dom.map.querySelectorAll('[id^="trigger-"]'));
    this.#dom.select = this.#dom.element.querySelector('.mobile-service-map__select');
    this.#dom.list = this.#dom.element.querySelector('.mobile-service-map__list');
    this.#dom.title = this.#dom.element.querySelector('.mobile-service-map__area-title');
    this.#dom.description = this.#dom.element.querySelector('.mobile-service-map__area-description');
    this.#dom.availability = this.#dom.element.querySelector('.mobile-service-map__area-availability');
  }

  /**
   * Add event listeners.
   */
  addEventListeners() {
    this.#dom.triggers.forEach(el=>el.addEventListener('click', this.handleTriggerClick.bind(this)));
    this.#dom.select.addEventListener('change', this.handleAreaChangeEvent.bind(this));
  }

  /**
   * Handle area change event by <select> element.
   * @param {Event} event - The event object.
   */
  handleAreaChangeEvent(event) {
    this.updateUI(event.target.value);
  }

  /**
   * Handle trigger-area click event in SVG map.
   * @param {Event} event - The event object.
   */
  handleTriggerClick(event) {
    this.updateUI('area-' + event.target.id.split('-')[1]);
  }

  /**
   * Update UI elements by area id
   * @param {string} areaId - The area id.
   */
  updateUI(areaId) {
    // deselect if already selected
    if (areaId === this.currentArea) areaId = '';

    this.updateMap(areaId);
    this.updateSelect(areaId);
    this.updateAreaInfo(areaId);
    this.currentArea = areaId;
  }

  /**
   * Update map selection
   * @param {string} areaId - The area id.
   */
  updateMap(areaId = '') {
    this.#dom.paths.forEach(path => path.classList.toggle(this.#activeClassName, path.id === areaId ));
  }

  /**
   * Update area info
   * @param {string} areaId - The area id.
   */
  updateAreaInfo(areaId = '') {
    const data = this.#areaData[areaId] || {};

    // hide area data if no title
    this.#dom.list.hidden = data.name ? false : true;

    this.#dom.title.textContent = data.name;
    this.#dom.description.textContent = data.description;
    this.#dom.availability.textContent = data.availability;

  }

  /**
   * Update select element value
   * @param {string} areaId - The area id.
   */
  updateSelect(areaId = '') {
    this.#dom.select.value = areaId;
  }

  /**
   * Initialize the mobile service map.
   */
  init(){
    if (this.#dom.map && this.#areaData) {
      this.findElements();
      this.addEventListeners();
    }
  }

}
